module.exports = __webpack_public_path__ + "static/img/coin.89fdb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coin.png
// module id = JLB4
// module chunks = 26